import React, { useEffect, useState } from 'react';
import { Button, Header, Image, List, Segment } from 'semantic-ui-react';
import { getTranslations, format } from './translations';

export const cardStyle = {
  width: '100%',
  margin: 0,
  padding: 10,
  color: 'var(--card-foreground)',
  background: 'var(--card)',
  border: '1px solid var(--border)',
  borderRadius: 'var(--radius)',
  boxShadow: 'var(--shadow-xl)',
  pointerEvents: 'auto',
  flexShrink: 0
};

export const headerRowStyle = { display: 'flex', alignItems: 'center', gap: 6 };

export const iconButtonStyle = { margin: 0, padding: 6, background: 'transparent', color: 'var(--muted-foreground)' };

/**
 * StarterPanel: three public starter circuits offered on the empty lab. Non-modal, collapsible
 * and dismissible. A card is a plain link to /experiments/:id?starter=<key>.
 */
const StarterPanel = ({ starters, current_locale, compact, onDismiss }) => {
  const [collapsed, setCollapsed] = useState(!!compact);
  // No room for the list: keep only the header, which still opens it
  useEffect(() => {
    if (compact) setCollapsed(true);
  }, [compact]);
  const t = getTranslations(current_locale);

  const handleToggle = () => setCollapsed((value) => !value);

  return (
    <Segment id="first-session-starter-panel" role="region" style={cardStyle} aria-labelledby="first-session-starter-title">
      <div style={headerRowStyle}>
        <Header as="h4" id="first-session-starter-title" style={{ margin: 0, flex: 1, color: 'var(--card-foreground)', fontSize: '0.95rem' }}>
          {t.panelTitle}
        </Header>
        <Button
          id="first-session-starter-toggle"
          type="button"
          icon={collapsed ? 'chevron down' : 'chevron up'}
          size="mini"
          basic
          style={iconButtonStyle}
          aria-expanded={!collapsed}
          aria-controls={collapsed ? undefined : 'first-session-starter-list'}
          aria-label={collapsed ? t.expand : t.collapse}
          onClick={handleToggle}
        />
        <Button
          id="first-session-starter-close"
          type="button"
          icon="close"
          size="mini"
          basic
          style={iconButtonStyle}
          aria-label={t.closePanel}
          onClick={onDismiss}
        />
      </div>
      {!collapsed && (
        <>
          <p style={{ margin: '4px 0 8px', fontSize: '0.85rem', color: 'var(--muted-foreground)' }}>{t.panelSubtitle}</p>
          <List id="first-session-starter-list" relaxed style={{ margin: 0 }}>
            {starters.map((starter) => {
              const label = (t.starters && t.starters[starter.key]) || starter.title;
              return (
                <List.Item
                  key={starter.key}
                  id={`first-session-starter-${starter.key}`}
                  as="a"
                  href={starter.url}
                  aria-label={format(t.openStarter, { title: label })}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    padding: 6,
                    borderRadius: 'var(--radius)',
                    border: '1px solid var(--border)',
                    marginTop: 6,
                    color: 'var(--card-foreground)'
                  }}
                >
                  {starter.thumbnail ? (
                    <Image
                      src={starter.thumbnail}
                      alt=""
                      style={{ width: 64, height: 40, objectFit: 'cover', borderRadius: 4, flexShrink: 0, background: 'var(--muted)' }}
                    />
                  ) : null}
                  <span style={{ fontSize: '0.9rem', fontWeight: 600, minWidth: 0, overflowWrap: 'anywhere' }}>{label}</span>
                </List.Item>
              );
            })}
          </List>
        </>
      )}
    </Segment>
  );
};

export default StarterPanel;
